import { getAssetPath } from "@/constants/constants";

const bug = getAssetPath("/img/bug.png");
const truck = getAssetPath("/img/maroon-truck.png");
const vwBus = getAssetPath("/img/vw-bus.png");

const rides = {
  state: {
    pickerOpen: false,
    rides: [
      {
        id: "truck",
        img: truck,
        name: "Truck"
      },
      {
        id: "vw-bus",
        img: vwBus,
        name: "VW Bus"
      },
      {
        id: "bug",
        img: bug,
        name: "1970 VW Bug"
      }
    ],
    selected: "truck",
    inAltState: false
  },

  getters: {
    selectedRide: state =>
      state.rides.filter(({ id }) => id === state.selected)[0]
  },

  mutations: {
    setInAltState(state, value) {
      state.inAltState = value;
    },

    setSelected(state, value) {
      state.selected = value;
    },

    setPickerOpen(state, value) {
      state.pickerOpen = value;
    }
  },

  actions: {
    closeRidePicker({ commit }) {
      commit("setPickerOpen", false);
    },

    openRidePicker({ commit }) {
      commit("setPickerOpen", true);
    },

    toggleRidePicker({ commit, state }) {
      commit("setPickerOpen", !state.pickerOpen);
    },

    selectRide({ commit }, ride) {
      commit("setSelected", ride);
    },

    toggleRideInAltState({ commit, state }) {
      commit("setInAltState", !state.inAltState);
    }
  }
};

export default rides;
